module.exports = __webpack_public_path__ + "static/media/7-1.1e3c2801.png";